"use strict";

var _generate = _interopRequireDefault(require("./generate"));

var _isValid = _interopRequireDefault(require("./is-valid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = {
  generate: _generate["default"],
  isValid: _isValid["default"]
};